<template lang="pug">
  .container-main
    cBox(v-loading="loading", :element-loading-fullscreen="false")
      el-form(:model="mchDetail", label-position="right", label-width="200px")
        h4 资料变更状态
          .more(@click="to('/merchants-information/edit-detail')") 更多信息
        el-row(:gutter="10")
          el-col(:span="24")
            el-form-item(label="商户资料变更状态")
              .green(v-if='auditStatus ===2') {{ auditStatus | merchants_audit_status}}
              .red(v-else-if='auditStatus === 3') {{ auditStatus | merchants_audit_status}}
              span(v-else) {{ auditStatus | merchants_audit_status}}
            el-form-item(label="钱包提现账号变更",v-if ="mchDetail.type ===1 && mchDetail.settle_type ===3") 
              .audit-wallet(v-for="item in auditWalletList", :key="item.wallet_id")
                .wallet-title {{item.wallet_title}}{{item.wallet_id?`${(item.wallet_id)}`:''}}
                .wallet-status-1(v-if='item.audit_status===1') 待审核
                .wallet-status-2(v-if='item.audit_status===2') 审核成功
                .wallet-status-3(v-if='item.audit_status===3') 审核失败
                .wallet-failed-reason(v-if='item.audit_status===3') {{item.failed_reason}}
          el-col(v-if='auditStatus === 3 && auditWalletList.length >0 && mchDetail.settle_type ===3 && !allFalse')
            el-form-item(label="操作")
              el-button(type="primary", @click="to('/merchants-wallet/edit')") 修改失败的钱包信息
        hr
        template(v-if="mchDetail.type === 1")
          h4 商户信息
            .more(@click="to('/merchants-information')") 更多信息
          el-row(:gutter="10")
            el-col(:span="24")
              el-form-item(label="商户名称") {{ mchDetail.mch_name || '未填写' }}
              el-form-item(label="经营人/责任人") {{ mchDetail.legal_per_name || '未填写' }} / {{ mchDetail.resp_per_name || '未填写' }}
              el-form-item(label="公司电话") {{ mchDetail.tel || '未填写' }}
              el-form-item(label="联系地址") {{ mchDetail.business_address || '未填写' }}
        template(v-if="mchDetail.type === 2")
          h4 个人商户信息
          el-row(:gutter="10")
            el-col(:span="24")
              el-form-item(label="商户类型") 个人
              el-form-item(label="个人姓名") {{ mchDetail.resp_per_name || '未填写' }}              
              el-form-item(label="证件号码") {{ mchDetail.resp_per_id_no || '未填写' | desensitization(4,14,18) }}
              el-form-item(label="营业执照")
                img(v-if="mchDetail.business_license_pic", :src="mchDetail.business_license_pic | image", @click="$zoom($options.filters.image(mchDetail.business_license_pic))").mch-image
                template(v-else) 未提交
            
              el-form-item(label="结算方式") {{ mchDetail.settle_type | settle_type_long }}
              el-form-item(label="证件类型") {{ mchDetail.resp_per_id_type | resp_per_id_type }}
              el-form-item(label='') &nbsp;
              el-form-item(label="身份证照片")
                el-row(:gutter="10")
                  el-col(:span="10")
                    img(v-if="mchDetail.resp_per_id_positive", :src="mchDetail.resp_per_id_positive | image",
                        @click="$zoom($options.filters.image(mchDetail.resp_per_id_positive))").mch-image
                    template(v-else) 未提交
                  el-col(:span="10")
                    img(v-if="mchDetail.resp_per_id_opposite", :src="mchDetail.resp_per_id_opposite | image",
                        @click="$zoom($options.filters.image(mchDetail.resp_per_id_opposite))").mch-image
                    template(v-else) 未提交
</template>

<script>
export default {
  data() {
    return {
      mchDetail: {},
      auditStatus: "",
      auditWalletList: [],
      loading: false,
      walletStatus: "",
      allFalse: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isMobile() {
      return window.browserInfo.isMobile;
    },
  },
  filters: {
    status(source) {
      if (!source && source !== 0) {
        return "-";
      }
      switch (parseInt(source)) {
        case 1:
          return "填写中";
        case 2:
          return "审批中";
        case 3:
          return "审批通过";
        case 4:
          return "审批失败";
        case 5:
          return "用户撤回修改";
        case 6:
          return "审批中";
        case 7:
          return "审批中";
        default:
          return source;
      }
    },
    resp_per_id_type(source) {
      switch (source) {
        case "01":
          return "身份证";
        default:
          return source;
      }
    },
  },
  methods: {
    getUserInfo() {
      return this.$store.dispatch("GET_USER_INFO");
    },
    async getDetail() {
      const { uname } = this.userInfo;
      try {
        this.loading = true;
        let data = await this.$store.dispatch("LAST_SUCCEED_MCH_DETAIL");
        let { settle_type } = await this.$store.dispatch("GET_MCH_DETAIL", uname);
        let { wallet_audit_list, wallet_status, status } = await this.$store.dispatch(
          "MCH_AUDIT_STATUS"
        );
        // 没有绑定手机或者邮件必须去绑定要一个
        if (!data.resp_per_telephone_no && !data.resp_per_email) {
          this.$router.replace("/reg/3");
        }

        this.mchDetail = data;
        this.mchDetail.settle_type = settle_type;
        this.auditStatus = status;
        this.walletStatus = wallet_status;
        if (wallet_audit_list && Array.isArray(wallet_audit_list)) {
          this.auditWalletList = wallet_audit_list;
        }
        this.allFalse = this.auditWalletList.every((item) => item.audit_status === 3);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
        const { code, msg } = error;
        this.$alert(`商家审批信息获取失败。${code}：${msg}`, {
          type: "error",
        });
      }
    },

    to(pathname) {
      this.$router.push(pathname);
    },
  },
  mounted() {
    // 例如从H5登陆登陆个人高级钱包

    if (this.isMobile) {
      this.$router.replace("/main-mobile");
    }
    this.getUserInfo().then((userInfo) => {
      if (userInfo.fill_info === 1 && this.$route.path !== "/reg/2") {
        this.$router.replace("/reg/2");
      } else {
        this.getDetail();
      }
    });
  },
};
</script>
<style lang="less" scoped>
.more {
  color: #275aa0;
  cursor: pointer;
  display: inline;
  margin-left: 20px;
}
.audit-wallet {
  display: flex;
  .wallet {
    &-title {
      margin-right: 40px;
    }
    &-status {
      &-2 {
        color: #67c23a;
      }
      &-3 {
        color: #f56c6c;
      }
    }
    &-failed-reason {
      margin-left: 40px;
    }
  }
}
</style>
